import scrollIntoView from 'scroll-into-view';

document.addEventListener('DOMContentLoaded', () => {
    const todayDeadlines = document.querySelector('.pa-day.w-max.today');
    if (todayDeadlines) {
        scrollIntoView(todayDeadlines, {
            time: 25,
            align: {
                left: 0.25,
            },
        });
    }
});
